var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJarHorizontalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    style: {
      backgroundColor: "#190a4d"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a841ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36a2ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jar",
    transform: "translate(-14 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_26585",
    "data-name": "Rectangle 26585",
    transform: "translate(14 16)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_60b39746be1c3f7bfb3b03f2_group_9270",
    "data-name": "60b39746be1c3f7bfb3b03f2_group_9270",
    transform: "translate(24 17.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39662",
    "data-name": "Path 39662",
    d: "M14.417-33.5v14.129a6.029,6.029,0,0,1-1.7,4.566A6.312,6.312,0,0,1,8.16-13.176,6.507,6.507,0,0,1,3.5-14.848a6.11,6.11,0,0,1-1.774-4.671H5.767a3.218,3.218,0,0,0,.62,2.018,2.091,2.091,0,0,0,1.712.721,2.055,2.055,0,0,0,1.672-.692,2.885,2.885,0,0,0,.576-1.9V-33.5Zm3.662,12.083a9.246,9.246,0,0,1,.966-4.3A7.077,7.077,0,0,1,21.67-28.6a6.986,6.986,0,0,1,3.705-1.009,6.506,6.506,0,0,1,3.129.721,6.349,6.349,0,0,1,2.148,1.816v-2.283h4.066v15.975H30.652v-2.336A6.005,6.005,0,0,1,28.5-13.853a6.573,6.573,0,0,1-3.157.735,6.789,6.789,0,0,1-3.677-1.038,7.266,7.266,0,0,1-2.625-2.927,9.4,9.4,0,0,1-.966-4.34Zm12.572.058a5.178,5.178,0,0,0-.576-2.523A4.066,4.066,0,0,0,28.522-25.5a4.162,4.162,0,0,0-2.1-.563,4.089,4.089,0,0,0-2.076.548,4.125,4.125,0,0,0-1.543,1.6,5.013,5.013,0,0,0-.591,2.494A5.179,5.179,0,0,0,22.8-18.9a4.257,4.257,0,0,0,1.557,1.659,3.955,3.955,0,0,0,2.062.576,4.162,4.162,0,0,0,2.1-.563,4.066,4.066,0,0,0,1.557-1.615,5.178,5.178,0,0,0,.574-2.519ZM42.7-26.867a5.676,5.676,0,0,1,2.033-1.99,5.654,5.654,0,0,1,2.87-.721v4.238H46.54a4.089,4.089,0,0,0-2.87.894,4.121,4.121,0,0,0-.966,3.114v7.959H38.668V-29.352h4.037Z",
    transform: "translate(32.33 40.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134472",
    "data-name": "Group 134472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39663",
    "data-name": "Path 39663",
    d: "M7.939,0A7.939,7.939,0,1,1,0,7.939,7.939,7.939,0,0,1,7.939,0Z",
    transform: "translate(5.404 9.736)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39664",
    "data-name": "Path 39664",
    d: "M494.616,456.747c-.155-4.459-2.968-7.367-7.534-7.78-3.5-.317-6.028,1.209-6.941,4.189a8.606,8.606,0,0,0-.353,2.107c-.07,1.415-.136,3.666-.171,5.31-.276-.183-.5-.332-.714-.492a1.591,1.591,0,0,0-2.357-.009,1.554,1.554,0,0,0,.271,2.365c1.235,1.116,2.262,2.032,3.233,2.88,1.077.944,1.856.571,2.225.258,1.506-1.264,2.777-2.419,3.89-3.532a1.788,1.788,0,0,0,.082-1.81,1.332,1.332,0,0,0-.834-.669,1.554,1.554,0,0,0-1.221.228l-.024.016-1.217.885-.009-.3a41.456,41.456,0,0,1,.044-5.06c.039-.381.1-.769.169-1.151a2.757,2.757,0,0,1,.191-.609,2.333,2.333,0,0,1,2.047-1.35,8.516,8.516,0,0,1,2.543.137,3.962,3.962,0,0,1,3.479,3.767c.146,4.552.145,8.6,0,12.383a3.786,3.786,0,0,1-4.026,3.849c-3.853.114-7.9.114-12.034.007a3.783,3.783,0,0,1-4.056-3.813c-.169-4.057-.171-8.281,0-12.556.084-2.155,1.532-3.527,3.972-3.767.192-.018.385-.026.589-.034a8.5,8.5,0,0,0,.868-.065c.055-.008.114-.017.167-.029a.457.457,0,0,0,.129-.023l.076-.026a2.071,2.071,0,0,0,.424-.169,4.73,4.73,0,0,0,2.246-2.047,4.993,4.993,0,0,0-.675-5.562.457.457,0,0,0-.64-.062l-2.311,1.907a.457.457,0,0,0-.072.626,1.558,1.558,0,0,1,.281,1.336,1.381,1.381,0,0,1-1.1.844q-.18.011-.357.03a.52.52,0,0,0-.058.007,7.243,7.243,0,0,0-6.68,6.984c-.2,4.025-.2,8.275,0,12.633a6.831,6.831,0,0,0,6.838,6.938c2.162.114,4.3.172,6.392.172,2.13,0,4.224-.059,6.254-.177,4.239-.247,6.774-2.879,6.952-7.222C494.738,464.45,494.75,460.564,494.616,456.747Z",
    transform: "translate(-468.008 -444.111)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJarHorizontalLogo);
export default __webpack_public_path__ + "static/media/jar-horizontal-logo.9280b0358896a19c7e9ace7389ef2f90.svg";
export { ForwardRef as ReactComponent };